
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorGenericInleftLeft25 as ObiThreewayAcuatorGenericInleftLeft25Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-generic-inleft-left-25.js';
 
 
 

 
 export const ObiThreewayAcuatorGenericInleftLeft25 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-generic-inleft-left-25',
   elementClass: ObiThreewayAcuatorGenericInleftLeft25Element,
   events: {
     
   }
  });
 
 